import styled from 'styled-components';
import { Row } from '../Row/Row';

export const GoBackWrapper = styled(Row)`
  align-items: center;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.spacing.s};
  cursor: pointer;
`;
